// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
https://unused-css.com/blog/css-shake-animation/
https://codepen.io/Mrshcom/pen/kNmBGm
*/

.strong-hover-shake {
  animation: tilt-n-move-shaking 0.15s infinite;
}

.spring-tilt-shake {
  animation: ring 3s 0.7s ease-in-out infinite;
  transform-origin: center top;
}

@keyframes tilt-shaking {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(5deg);
  }
  50% {
    transform: rotate(0eg);
  }
  75% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

@keyframes tilt-n-move-shaking {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  25% {
    transform: translate(5px, 5px) rotate(5deg);
  }
  50% {
    transform: translate(0, 0) rotate(0eg);
  }
  75% {
    transform: translate(-5px, 5px) rotate(-5deg);
  }
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
}

@keyframes vertical-shaking {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(5px);
  }
  50% {
    transform: translateY(-5px);
  }
  75% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes horizontal-shaking {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(5px);
  }
  50% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes jump-shaking {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateY(-9px);
  }
  35% {
    transform: translateY(-9px) rotate(17deg);
  }
  55% {
    transform: translateY(-9px) rotate(-17deg);
  }
  65% {
    transform: translateY(-9px) rotate(17deg);
  }
  75% {
    transform: translateY(-9px) rotate(-17deg);
  }
  100% {
    transform: translateY(0) rotate(0);
  }
}

@keyframes skew-x-shake {
  0% {
    transform: skewX(-15deg);
  }
  5% {
    transform: skewX(15deg);
  }
  10% {
    transform: skewX(-15deg);
  }
  15% {
    transform: skewX(15deg);
  }
  20% {
    transform: skewX(0deg);
  }
  100% {
    transform: skewX(0deg);
  }
}

@keyframes skew-y-shake {
  0% {
    transform: skewY(-15deg);
  }
  5% {
    transform: skewY(15deg);
  }
  10% {
    transform: skewY(-15deg);
  }
  15% {
    transform: skewY(15deg);
  }
  20% {
    transform: skewY(0deg);
  }
  100% {
    transform: skewY(0deg);
  }
}

@keyframes ring {
  0% {
    transform: rotate(0);
  }
  1% {
    transform: rotate(30deg);
  }
  3% {
    transform: rotate(-28deg);
  }
  5% {
    transform: rotate(34deg);
  }
  7% {
    transform: rotate(-32deg);
  }
  9% {
    transform: rotate(30deg);
  }
  11% {
    transform: rotate(-28deg);
  }
  13% {
    transform: rotate(26deg);
  }
  15% {
    transform: rotate(-24deg);
  }
  17% {
    transform: rotate(22deg);
  }
  19% {
    transform: rotate(-20deg);
  }
  21% {
    transform: rotate(18deg);
  }
  23% {
    transform: rotate(-16deg);
  }
  25% {
    transform: rotate(14deg);
  }
  27% {
    transform: rotate(-12deg);
  }
  29% {
    transform: rotate(10deg);
  }
  31% {
    transform: rotate(-8deg);
  }
  33% {
    transform: rotate(6deg);
  }
  35% {
    transform: rotate(-4deg);
  }
  37% {
    transform: rotate(2deg);
  }
  39% {
    transform: rotate(-1deg);
  }
  41% {
    transform: rotate(1deg);
  }

  43% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}

input.is-invalid ~ .goerror {
  animation: tooltipAppear 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

/* Define the appear animation (fade in + scale up) */
@keyframes tooltipAppear {
  0% {
    opacity: 0;
    transform: scale(0.85);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Animations.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;EACE,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,sCAAsC;EACxC;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,wEAAwE;AAC1E;;AAEA,qDAAqD;AACrD;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":["/*\nhttps://unused-css.com/blog/css-shake-animation/\nhttps://codepen.io/Mrshcom/pen/kNmBGm\n*/\n\n.strong-hover-shake {\n  animation: tilt-n-move-shaking 0.15s infinite;\n}\n\n.spring-tilt-shake {\n  animation: ring 3s 0.7s ease-in-out infinite;\n  transform-origin: center top;\n}\n\n@keyframes tilt-shaking {\n  0% {\n    transform: rotate(0deg);\n  }\n  25% {\n    transform: rotate(5deg);\n  }\n  50% {\n    transform: rotate(0eg);\n  }\n  75% {\n    transform: rotate(-5deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n@keyframes tilt-n-move-shaking {\n  0% {\n    transform: translate(0, 0) rotate(0deg);\n  }\n  25% {\n    transform: translate(5px, 5px) rotate(5deg);\n  }\n  50% {\n    transform: translate(0, 0) rotate(0eg);\n  }\n  75% {\n    transform: translate(-5px, 5px) rotate(-5deg);\n  }\n  100% {\n    transform: translate(0, 0) rotate(0deg);\n  }\n}\n\n@keyframes vertical-shaking {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateY(5px);\n  }\n  50% {\n    transform: translateY(-5px);\n  }\n  75% {\n    transform: translateY(5px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@keyframes horizontal-shaking {\n  0% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(5px);\n  }\n  50% {\n    transform: translateX(-5px);\n  }\n  75% {\n    transform: translateX(5px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n@keyframes jump-shaking {\n  0% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateY(-9px);\n  }\n  35% {\n    transform: translateY(-9px) rotate(17deg);\n  }\n  55% {\n    transform: translateY(-9px) rotate(-17deg);\n  }\n  65% {\n    transform: translateY(-9px) rotate(17deg);\n  }\n  75% {\n    transform: translateY(-9px) rotate(-17deg);\n  }\n  100% {\n    transform: translateY(0) rotate(0);\n  }\n}\n\n@keyframes skew-x-shake {\n  0% {\n    transform: skewX(-15deg);\n  }\n  5% {\n    transform: skewX(15deg);\n  }\n  10% {\n    transform: skewX(-15deg);\n  }\n  15% {\n    transform: skewX(15deg);\n  }\n  20% {\n    transform: skewX(0deg);\n  }\n  100% {\n    transform: skewX(0deg);\n  }\n}\n\n@keyframes skew-y-shake {\n  0% {\n    transform: skewY(-15deg);\n  }\n  5% {\n    transform: skewY(15deg);\n  }\n  10% {\n    transform: skewY(-15deg);\n  }\n  15% {\n    transform: skewY(15deg);\n  }\n  20% {\n    transform: skewY(0deg);\n  }\n  100% {\n    transform: skewY(0deg);\n  }\n}\n\n@keyframes ring {\n  0% {\n    transform: rotate(0);\n  }\n  1% {\n    transform: rotate(30deg);\n  }\n  3% {\n    transform: rotate(-28deg);\n  }\n  5% {\n    transform: rotate(34deg);\n  }\n  7% {\n    transform: rotate(-32deg);\n  }\n  9% {\n    transform: rotate(30deg);\n  }\n  11% {\n    transform: rotate(-28deg);\n  }\n  13% {\n    transform: rotate(26deg);\n  }\n  15% {\n    transform: rotate(-24deg);\n  }\n  17% {\n    transform: rotate(22deg);\n  }\n  19% {\n    transform: rotate(-20deg);\n  }\n  21% {\n    transform: rotate(18deg);\n  }\n  23% {\n    transform: rotate(-16deg);\n  }\n  25% {\n    transform: rotate(14deg);\n  }\n  27% {\n    transform: rotate(-12deg);\n  }\n  29% {\n    transform: rotate(10deg);\n  }\n  31% {\n    transform: rotate(-8deg);\n  }\n  33% {\n    transform: rotate(6deg);\n  }\n  35% {\n    transform: rotate(-4deg);\n  }\n  37% {\n    transform: rotate(2deg);\n  }\n  39% {\n    transform: rotate(-1deg);\n  }\n  41% {\n    transform: rotate(1deg);\n  }\n\n  43% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(0);\n  }\n}\n\ninput.is-invalid ~ .goerror {\n  animation: tooltipAppear 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n}\n\n/* Define the appear animation (fade in + scale up) */\n@keyframes tooltipAppear {\n  0% {\n    opacity: 0;\n    transform: scale(0.85);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
